import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, y = 44, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Eyebrow({ children, light = false }) {
  return (
    <p
      className={`mb-5 text-xs font-semibold uppercase tracking-[0.35em] ${
        light ? "text-borgonha" : "text-rosa"
      }`}
    >
      {children}
    </p>
  );
}
